export default "__VITE_ASSET__l04dSS7d__"